import { Box } from '@betterment/samba-react';

import { MessageFragment } from '../../../../../graphql/fragments/message.generated';
import MessageBox from '../../../../../Shared/components-v2/message-box/message-box';

type Props = { messages: MessageFragment[] };

export const PortfolioMessages: React.FC<Props> = ({ messages }) =>
  messages.length > 0 && (
    <Box css={{ marginY: 3 }}>
      <MessageBox messages={messages} location="PortfolioStrategyCard" />
    </Box>
  );
